import { ensureSubscription, pushSupported, type SubscriptionJson, swRegistration } from "../cabinet/index.js";

/**
 * Web Push в браузере. На iPhone push работает с iOS 16.4 и только у приложения, добавленного на главный экран;
 * разрешение спрашиваем только по нажатию кнопки (иначе Safari откажет).
 */

export { pushSupported };

export const isIos = (): boolean => /iPad|iPhone|iPod/.test(navigator.userAgent) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);

export const isStandalone = (): boolean =>
  window.matchMedia?.("(display-mode: standalone)").matches || (navigator as Navigator & { standalone?: boolean }).standalone === true;

/** iPhone в Safari без установки на главный экран: push недоступен, нужна подсказка. */
export const needsInstall = (): boolean => isIos() && !isStandalone();

/** Регистрация service worker; в dev его нет, поэтому не ждём вечно. */
const registration = () => swRegistration();

export async function currentSubscription(): Promise<PushSubscription | null> {
  const reg = await registration();
  return reg ? reg.pushManager.getSubscription() : null;
}

/** Спросить разрешение и подписаться (с текущим ключом сервера). null, если пользователь отказал или браузер не умеет. */
export async function subscribe(publicKey: string): Promise<SubscriptionJson | null> {
  if (!pushSupported()) return null;
  // Safari считает запрос разрешения ответом на нажатие, только если он идёт первым, до других await.
  const permission = await Notification.requestPermission();
  if (permission !== "granted") return null;
  const reg = await registration();
  if (!reg) return null;
  return ensureSubscription(reg, publicKey);
}

export async function unsubscribe(): Promise<string | null> {
  const sub = await currentSubscription();
  if (!sub) return null;
  const endpoint = sub.endpoint;
  await sub.unsubscribe();
  return endpoint;
}
